import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { NouisliderComponent } from 'ng2-nouislider';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { CalculatedResultComponent } from './calculated-result/calculated-result.component';
import * as wNumb from 'wnumb';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalculatorComponent implements OnInit {

  @ViewChild("rangeslider", {static:false}) mSliderComp: NouisliderComponent;
  @ViewChild("rangeslider", { read: ElementRef, static:false }) mSliderEl: ElementRef;
  
  constructor(private modalService: NgbModal) { }
  electricityCost:string = '8';
  panelCapacity:string = '1';
  customerBudget:string = '100000';
  roofTopArea:string = '25';
  calculator;
  record:Object;
  
  ngOnInit() {
    this.calculator = {
        criteria: this.tabs[0].value,
        totalArea:null,
        areaUnit:this.areaUnits[0].value,
        availableArea:'',
        panelCapacity:'',
        customerBudget:'',
        state: this.states[0].value,
        category:this.categories[0].value,
        electricityCost:this.electricityCost
    }
  }

  updateElectCost(sliderCost){
    this.electricityCost = sliderCost;
  }

  updatePanelCapacity(capacity){
    this.panelCapacity = capacity;
  }

  updateCustomerBudget(budget){
    this.customerBudget = budget;
  }

  updateRoofTopArea(area){
    this.roofTopArea = area;
  }

  public tabs = [
      { value: 1, display: 'Total Roof Top Area' },
      { value: 2, display: 'Solar Panel Capacity you want to install' },
      { value: 3, display: 'Your budget' }
  ];

  public areaUnits = [
    { value: 'sqm', display: 'Sq. M.' },
    { value: 'sqf', display: 'Sq. Feet' }
  ];

  public states = [
    { value: '0', display: 'Select State' },
    { value: '35', display: 'ANDAMAN and NICOBAR ISLANDS' },
    { value: '28', display: 'ANDHRA PRADESH' },
    { value: '12', display: 'ARUNACHAL PRADESH' },
    { value: '18', display: 'ASSAM' }
  ];

  public categories = [
      { value: '0', display: 'Select Category' },
      { value: '1', display: 'Residential' },
      { value: '2', display: 'Institutional' },
      { value: '3', display: 'Industrial' },
      { value: '4', display: 'Commerical' },
      { value: '5', display: 'Government' },
      { value: '6', display: 'Social Sector' }
  ];
  
  electrycityCostConfig: any = {
    connect: [true,false],
    start: this.electricityCost,
    step: 0.25,
    range: {
      min: 4,
      max: 20
    },
    pips: {mode: 'count', values: 5},
    tooltips:true,
    format: wNumb({
      decimals: 2
    })
  };

  panelCapacityConfig:any = {
    connect: [true,false],
    start: this.panelCapacity,
    // step: 4,
    range: {
      min: 1,
      max: 500
    },
    pips: {mode: 'count', values: 5, density:5},
    tooltips:true,
    format: wNumb({
      decimals: 0
    })
  };

  customerBudgetConfig:any = {
    connect: [true,false],
    start: this.customerBudget,
    // step: 4,
    range: {
      min: 100000,
      max: 100000000
    },
    pips: {mode: 'count', values: 5, density:5},
    tooltips:true,
    format: wNumb({
        decimals: 0,
        prefix: '&#8377; '
    })
  };

  roofTopAreaConfig:any = {
    connect: [true,false],
    start: this.roofTopArea,
    // step: 4,
    range: {
      min: 1,
      max: 100
    },
    pips: {mode: 'count', values: 5, density:5},
    tooltips:true,
    format: wNumb({
      decimals: 0
    })
  };

  closeResult: string;

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  open(content,id) {
    console.log(id);
    let productId = id;
    this.modalService.open(content,{size:'lg',scrollable: true })
    .result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openModal(form:NgForm){
   console.log('form',form.value);
   const modalRef = this.modalService.open(CalculatedResultComponent,{size:'lg',scrollable: true })
   modalRef.componentInstance.formData = form.value;
  }
}